<template>
    <v-container  v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap>
                <v-flex sm4>
                    <count-up :endVal="currentCommitteeCount" text="Committees this Parliament" />
                </v-flex>
                 <v-flex sm4>
                    <count-up :endVal="committeeCount" text="Committees in total" />
                </v-flex>
                <v-flex sm4>
                    <count-up :endVal="percentage" :countOptions="totalStatsOptions"  text="of Parliamentarians have <br/>committee service" />
                </v-flex>
            </v-layout>
            <br />
         
            <v-layout row wrap align-left>
                <v-flex xs12 md12 xl6 order-xs2 pb-xs-3>
                    <v-btn-toggle v-model="chartType" class="pb-0 mt-4 mb-0 transparent handbook_toggleButton" :mandatory="true">
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'committeesByType'"><span class="long-button-text">By type</span></v-btn>
                            </template>
                            <span>Committees by type</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'membersByType'"><span class="long-button-text">Committee members</span></v-btn>
                            </template>
                            <span>Committee members by type</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'wordCloud'"><span class="long-button-text">Word cloud</span></v-btn>
                            </template>
                            <span>Word cloud</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'longestRunningCommittees'"><span class="long-button-text">Longest running committees</span></v-btn>
                            </template>
                            <span>Longest running committees</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'largestCommittees'"><span class="long-button-text">Largest committees</span></v-btn>
                            </template>
                            <span>Largest committees</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-flex>
                <v-flex xs12 sm6 md4 xl3 order-xs1>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Filter by committee types"
                      v-model="COMMITTEE_TYPES_SELECTED"
                      :items="COMMITTEE_TYPE_OPTIONS"
                      item-text="Filter"
                      item-value="Filter"
                      auto-select-first
                      multiple
                       clearable
                      small-chips
                      deletable-chips
                      v-on:change="FILTERBY_TYPE">
                      <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteCommitteeSelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{COMMITTEE_TYPES_SELECTED.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
                <v-flex xs12 sm6 md4 xl3>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Select a Parliament"
                      v-model="SELECTED_PARLIAMENTS"
                      :items="this.$store.getters.GET_PARLIAMENTS_ORDERED"
                      item-text="Name"
                      item-value="PID"
                      v-on:change="FILTERBY_PARLIAMENT"
                      :filter="FILTER_PARLIAMENT_OPTIONS"
                      auto-select-first
                      multiple
                      small-chips
                      clearable
                      deletable-chips>
                      <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteParliamentSelectionItem(item.Name)" small close v-if="index == 0">{{item.Name}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                        </template>
                      <template
                        v-slot:prepend-item
                        v-if="this.$store.getters.GET_PARLIAMENTS.length > 0">
                        <v-list-tile
                          v-on:click="CLICK_CURRENTPARLIAMENT"
                          :value="currentParliamentValue"
                          ripple>
                          <v-list-tile-action>
                            <v-icon>{{ currentParliamentIcon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>Current Parliament</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
            </v-layout>


            <chart v-show="chartType === 'membersByType'" :chartData="membersByType" />
    
            <chart v-show="chartType === 'committeesByType'" :chartData="committeeTypeChart" />

            <chart v-show="chartType === 'wordCloud'" :chartData="wordCloud" />
            
             <chart v-show="chartType === 'longestRunningCommittees'" :chartData="longestRunningCommittees" />
             <chart v-show="chartType === 'largestCommittees'" :chartData="largestCommittees" />

            <br />
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                        <v-subheader
                        >
                        Sort by:
                        </v-subheader>
                    <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <div class="stats-table"> 
                <v-data-table
                    :headers="HEADERS"
                    :items="DATATABLE_COMMITTEES"
                    :rows-per-page-items="ROWS_LISTITEMS"
                    :pagination.sync="PAGINATION"
                    v-on:update:pagination="UPDATE_PAGINATION"
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                >
                    <template v-slot:items="props">
                        <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_COMMITTEE,  params: { CID: props.item.CID}}">
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item pt-2">
                                        <h3 class="pb-xs-0">{{ props.item.CommitteeName }}</h3>
                                    </div>
                                    <div class="flex-item">
                                        <v-chip :class="props.item.CommitteeType.indexOf('General Purpose') > -1 ? 'ma-0 generalPurposeStanding' : 'ma-0'"
                                            small label :color="props.item.CommitteeChamber == 'Senate'
                                                ? $store.state.COLOUR_SENATE
                                                : props.item.CommitteeChamber == 'House'
                                                ? $store.state.COLOUR_REPRESENTATIVES
                                                : $store.state.COLOUR_JOINT">
                                            {{ props.item.CommitteeType }}
                                        </v-chip>
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="Service start">
                                        {{ props.item.ServiceStartDate | stringDateFormat }}
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="Service end">
                                        {{ props.item.Current ? "Current" : "" }}
                                        {{ props.item.ServiceEndDate | stringDateFormat }}
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="Total members">
                                        {{ props.item.MemberCount === 0 ? "" : props.item.MemberCount }}
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="Service length">
                                        {{ getDateLength(props.item.ServiceLength) }}
                                    </div>
                                </div>
                            </td>
                        </router-link>
                        <router-link v-else
                            class="tr"
                            :to="{
                            name: $store.state.ROUTE_COMMITTEE,
                            params: { CID: props.item.CID},
                            }"
                        >
                            <td class="text-xs-left">
                                <v-chip :class="props.item.CommitteeType.indexOf('General Purpose') > -1 ? 'generalPurposeStanding' : ''"
                                    small label
                                    :color="props.item.CommitteeChamber == 'Senate'
                                        ? $store.state.COLOUR_SENATE
                                        : props.item.CommitteeChamber == 'House'
                                        ? $store.state.COLOUR_REPRESENTATIVES
                                        : $store.state.COLOUR_JOINT">
                                    {{ props.item.CommitteeType }}
                                </v-chip>
                            </td>
                            <td class="text-xs-left">{{ props.item.CommitteeName }}</td>
                            <td class="text-xs-left">
                                {{ props.item.ServiceStartDate | stringDateFormat }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.Current ? "Current" : "" }}
                                {{ props.item.ServiceEndDate | stringDateFormat }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.MemberCount }}
                            </td>
                            <td class="text-xs-left">
                                {{ getDateLength(props.item.ServiceLength) }}
                            </td>
                        </router-link>
                    </template>
                    <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search found no results.
                    </v-alert>
                    </template>
                </v-data-table>
            </div>
            <br />
        </template>
    </v-container>
</template>

<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import Chart from './Chart.vue';
import CountUp from './CountUp.vue';
import axios from 'axios';
import Highcharts from 'highcharts';
import orderBy from 'lodash.orderby';

window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseStats();
    },
    components: {
        Loader,
        StatisticalHeader,
        Chart,
        CountUp
    },
    methods: {
        deleteCommitteeSelectionItem(item) {
            this.COMMITTEE_TYPES_SELECTED = this.COMMITTEE_TYPES_SELECTED.filter(find => find !== item);
            this.FILTERBY_TYPE(this.COMMITTEE_TYPES_SELECTED);
        },
        deleteParliamentSelectionItem(item) {
            this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find.Name !== item.Name);
            this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
        },
        getDateLength(days){
                const years = Math.floor(days / 365);
                const months = Math.floor((days - years * 365) / 30);
                const d = Math.round(days - years * 365 - months * 30);

                let res = [];
                if (years > 1) {
                    res.push(years + ' years');
                }
                if (years == 1) {
                    res.push(years + ' year');
                }
                if (months > 1) {
                    res.push(months + ' months');
                }
                if (months == 1) {
                    res.push(months + ' month');
                }
                if (d > 1) {
                    res.push(d + ' days');
                }
                if (d == 1) {
                    res.push(d + ' day');
                }
                let detailDiff = res.join(', ');

                return detailDiff;
            },
        // onToggle(){
        //     this.DATATABLE_COMMITTEES = this.committeeData.filter(h => this.toggleChambers.indexOf(h.Chamber.toLowerCase()) > -1
        //             && this.toggleType.indexOf(h.Type.replace(h.Chamber + ' ', '')) > -1);
        // },
        getColor(chamber){
            if (chamber == 'House'){
                return this.$store.state.COLOUR_REPRESENTATIVES;
            }
            else if (chamber == 'Senate'){
                return this.$store.state.COLOUR_SENATE_BRIGHT;
            }
            else if (chamber == 'Joint'){
                return this.$store.state.COLOUR_JOINT;
            }
        },
        UPDATE_PAGINATION: function (options) {
            this.$gtag.event("committees by name pagination items per page", {
                event_category: "filters",
                event_label: `items per page: ${options.rowsPerPage}`,
                value: 1,
            });
            this.$gtag.event("committees by name pagination page", {
                event_category: "filters",
                event_label: `page: ${options.page}`,
                value: 1,
            });
            this.$gtag.event(`committees by name sorting`, {
                event_category: "sorting",
                event_label: `sort by ${options.sortBy} ${
                options.descending ? "DESC" : "ASC"
                }`,
                value: 1,
            });
  
            return this.PAGINATION;
        },
        initialiseStats() {
            this.loading = true;
            const mpOrSenator = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];

            const committeesURL ="committees?Select=CID,CommitteeChamber,CommitteeType,CommitteeName";
                axios.get(`api/${committeesURL}`).then((response) => {
                this.committeeData = response.data.value;
                this.DATATABLE_COMMITTEES = this.committeeData;
                  this.FILTER_COMMITTEES();
            });


            const url = `StatisticalInformation/CommitteeStatistics?mpOrSenator=${mpOrSenator}&fullData=true`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.committeeCount = response.data.Committees.length;
                    this.stats = response.data.StatisticsByParliament;
                    // this.committees = response.data.Committees.slice().reverse();
                    this.currentParliament = Math.max(...response.data.StatisticsByParliament.map(s => parseInt(s.ParliamentNumber)));
                    this.totalStats = response.data.StatisticsByParliament.find(p => p.ParliamentNumber == '0');
                    this.currentCommitteeCount = response.data.StatisticsByParliament.find(p => p.ParliamentNumber == this.currentParliament).CommitteeCount;
                    this.percentage = (this.totalStats.ParliamentarianOnCommitteesCount/this.totalStats.ParliamentarianCount)*100;
                    // this.DATATABLE_COMMITTEES = this.committees;
                  
                    this.loading = false;
         
                });
        },
        filterMpOrSenator() {
            this.initialiseStats();
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items
                .map(i => ({ Date: new Date(i.Date).toLocaleDateString(), ...i.Parties.reduce((ac,a) => ({...ac,[a.Party]: a.WomenCount }),{}) }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Committee statistics';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        FILTERBY_TYPE: function (types) {
            //No types, add all
            if (types.length == 0) {
                this.COMMITTEE_TYPES_SELECTED.push("All types");
            } else {
                //Went from no items (on load) to multiple. Remove 'All types'
                if (
                this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0 &&
                this.COMMITTEE_TYPES_SELECTED.length > 1 &&
                this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1
                ) {
                this.COMMITTEE_TYPES_SELECTED.splice(
                    this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
                    1
                );
                }
                //Previous list didn't have all types, now we are adding it, allow this to happen
                else if (
                this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1 &&
                (this.COMMITTEE_TYPES_SELECTED_PREVIOUS.indexOf("All types") == -1 ||
                    this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0)
                ) {
                this.COMMITTEE_TYPES_SELECTED = ["All types"];
                }
                //In all other cases, remove 'all types' if user has selected other options
                else if (this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1) {
                this.COMMITTEE_TYPES_SELECTED.splice(
                    this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
                    1
                );
                }
            }

            this.COMMITTEE_TYPES_SELECTED_PREVIOUS = types;
            return this.FILTER_COMMITTEES();
        },
        FILTERBY_PARLIAMENT: function (parliaments) {
            this.$gtag.event("committees by parliament parliament filter", {
                event_category: "filters",
                event_label: `parliaments selected: ${
                parliaments.length > 0 ? parliaments.join(",") : "none"
                }`,
                value: 1,
            });
            return this.FILTER_COMMITTEES();
        },
        FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
            const pId = item.PID;
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
            );
        },
        CLICK_CURRENTPARLIAMENT: function () {
            this.$nextTick(() => {
                let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                            let currentParliament = parliaments[0].PID;
                            if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                                let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                                if (index > -1) {
                                    this.SELECTED_PARLIAMENTS.splice(index, 1);
                                }
                            } else {
                                this.SELECTED_PARLIAMENTS.push(currentParliament);
                            }
                this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
            });
        },
        FILTER_COMMITTEES: function () {
            // create a function scoped var to hold all Committees
            let OBJ_records = this.committeeData;
            let OBJ_types = [];
            let index = 0;

            var currentObjRecords = [];
            if (this.SELECTED_PARLIAMENTS.length == 0){
                OBJ_records = this.committeeData;
            }

            for (index = 0; index < this.SELECTED_PARLIAMENTS.length; ++index) {
                var internalRecords = this.committeeData;

                //  FILTERS_SELECTED_PARLIAMENTS
                var parliament = this.$store.getters.GET_PARLIAMENT_BYPID(
                parseInt(this.SELECTED_PARLIAMENTS[index])
                );
                if (!parliament) {
                continue;
                }

                var existingIDs = currentObjRecords.map((obj) => obj.CID);

                var filtered = internalRecords
                .filter((Obj) => Obj.ParliamentList.indexOf(parliament.PID) > -1 && existingIDs.indexOf(Obj.CID) == -1)
                .map((record) => ({ ...record, Parliament: parliament.PID }));

                currentObjRecords = currentObjRecords.concat(filtered);
            }

            OBJ_records = currentObjRecords;

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                if (OBJ_records.length === 0) {
                OBJ_records = this.committeeData;
                }

                var showAll = false;

                for (index = 0; index < this.COMMITTEE_TYPES_SELECTED.length; ++index) {
                var txtVal = this.COMMITTEE_TYPES_SELECTED[index].replace(
                    " of Representatives",
                    ""
                );
                if (txtVal == "All types") {
                    showAll = true;
                }
                OBJ_types = OBJ_types.concat(
                    OBJ_records.filter((Obj) => Obj.CommitteeType === txtVal)
                );
                }

                if (showAll) {
                OBJ_types = OBJ_records;
                }
            }

            const recordsResult = OBJ_types;

            let query = this.$router.query || {};

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                query.committeeTypes = this.COMMITTEE_TYPES_SELECTED.join(",");
            }

            if (this.SELECTED_PARLIAMENTS.length > 0) {
                query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
            }

          

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                this.DATATABLE_COMMITTEES = this._.sortBy(
                recordsResult,
                "CommitteeName"
                );
            } else {
                this.DATATABLE_COMMITTEES = [];
            }

            if (Object.keys(query).length > 0) {
                history.replaceState(
                {},
                null,
                this.$route.path +
                    "?" +
                    Object.keys(query)
                    .map((key) => {
                        return key + "=" + query[key];
                    })
                    .join("&")
                );
            } else {
                history.replaceState({}, null, this.$route.path);
            }


            return true;
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
    }, 
    computed: {
        
        currentParliamentIcon: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
            let currentParliament = parlArray[0].PID;
            if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                return '$vuetify.icons.checkboxOn';
            } else {
                return '$vuetify.icons.checkboxOff';
            }
        },
        currentParliamentValue: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS;
            if (
                this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
            ) {
                return parlArray[parlArray.length - 1].PID;
            } else {
                return false;
            }
        },
        csvDownloadIcon() {
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass() {
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
        committeeTypeChart() {
            const series = [ 'Senate Standing', 'Senate Legislative and General Purpose Standing', 'Senate Estimates',
            'Senate Select', 'House Standing','House Select', 'Joint Standing', 'Joint Statutory','Joint Select']
                .map(h => ({
                name: h,
                data: [],
                maxPointWidth: 50,
                visible: (this.COMMITTEE_TYPES_SELECTED.indexOf(h.replace('House', 'House of Representatives')) > -1 
                || this.COMMITTEE_TYPES_SELECTED[0] === "All types")
            }));

            const categories = [];

            var data = this.stats;

            data.forEach(d => {
                if (d.ParliamentNumber != 0){
                    if (this.SELECTED_PARLIAMENTS.length == 0 || this.SELECTED_PARLIAMENTS.indexOf(d.ParliamentNumber) > -1) {
                        categories.push(d.ParliamentNumber);

                        series.forEach(s => {
                            
                            if (d.CommitteeTypeCounters != null){
                                const type = d.CommitteeTypeCounters.find(c => c.CommitteeType === s.name);
                                if (type){
                                    if ((this.COMMITTEE_TYPES_SELECTED.indexOf(type.CommitteeType.replace('House', 'House of Representatives')) > -1)
                                    || this.COMMITTEE_TYPES_SELECTED[0] === "All types") {

                                        if (type.CommitteeChamber == 'House'){
                                            s.color = this.$store.state.COLOUR_REPRESENTATIVES;
                                        }
                                        else if (type.CommitteeChamber == 'Senate'){
                                            s.color = this.$store.state.COLOUR_SENATE_BRIGHT;
                                        }
                                        else if (type.CommitteeChamber == 'Joint'){
                                            s.color = this.$store.state.COLOUR_JOINT;
                                        }
                                        s.data.push(type.CommitteeCount);
                                    } 
                                    else {
                                        s.data.push(null);
                                    }
                                }
                                else {
                                        s.data.push(null);
                                    }
                            }
                            else {
                                s.data.push(null);
                            }
                        });
                    }
                }
            });

            return {
                chart: {
                    type:  'column' ,
                    height: 500,
                },
                title: {
                    text: 'Committee types by Parliament'
                },
                accessibility: {
                    point: {
                        valueDescriptionFormat: '{index}. {point.category}, {point.y:,.0f}.'
                    }
                },
                xAxis: {
                    categories: categories,
                    tickmarkPlacement: 'on',
                    title: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    }
                },
                tooltip: {
                    // pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})<br/>',
                    // split: true
                },
                exporting: {
                    filename: 'Committee types by Parliament'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                    },
                },
                series
            }
        },
        membersByType() {
            const series = [ 'Senate Standing', 'Senate Legislative and General Purpose Standing', 'Senate Estimates',
            'Senate Select', 'House Standing','House Select', 'Joint Standing', 'Joint Statutory','Joint Select']
                .map(h => ({
                name: h,
                data: [],
                maxPointWidth: 50,
                visible: (this.COMMITTEE_TYPES_SELECTED.indexOf(h.replace('House', 'House of Representatives')) > -1 
                || this.COMMITTEE_TYPES_SELECTED[0] === "All types")
            }));

            const categories = [];

            var data = this.stats;

            data.forEach(d => {
                if (d.ParliamentNumber != 0){
                    if (this.SELECTED_PARLIAMENTS.length == 0 || this.SELECTED_PARLIAMENTS.indexOf(d.ParliamentNumber) > -1) {
                        categories.push(d.ParliamentNumber);

                        series.forEach(s => {
                            
                            if (d.CommitteeTypeCounters != null){
                                const type = d.CommitteeTypeCounters.find(c => c.CommitteeType === s.name);
                                if (type){
                                    if ((this.COMMITTEE_TYPES_SELECTED.indexOf(type.CommitteeType.replace('House', 'House of Representatives')) > -1)
                                    || this.COMMITTEE_TYPES_SELECTED[0] === "All types") {

                                        if (type.CommitteeChamber == 'House'){
                                            s.color = this.$store.state.COLOUR_REPRESENTATIVES;
                                        }
                                        else if (type.CommitteeChamber == 'Senate'){
                                            s.color = this.$store.state.COLOUR_SENATE_BRIGHT;
                                        }
                                        else if (type.CommitteeChamber == 'Joint'){
                                            s.color = this.$store.state.COLOUR_JOINT;
                                        }
                                        s.data.push(type.TotalMemberCount);
                                    } 
                                    else {
                                        s.data.push(0);
                                    }
                                }
                                else {
                                        s.data.push(0);
                                    }
                            }
                            else {
                                s.data.push(0);
                            }
                        });
                    }
                }
            });

            return {
                chart: {
                    type: 'column',
                    height: 500,
                },
                title: {
                    text: 'Total committee members by committee type'
                },
                exporting: {
                    filename: 'Total committee members by committee type'
                },
                accessibility: {
                    point: {
                        valueDescriptionFormat: '{index}. {point.category}, {point.y:,.0f}.'
                    }
                },
                xAxis: {
                    maxPadding: 0,
                    type: 'category',
                    categories: categories,
                    tickmarkPlacement: 'on',
                    title: {
                        enabled: false
                    },
                    crosshair: true,
                    lineWidth: 1,
                    margin: 50,
                    tickWidth: 0
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                     visible: true,
                    startOnTick: false,
                    endOnTick: false
                },
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: {point.y:,.0f} total committee members<br/>',
                    split: false
                },
                plotOptions: {
                    series: {
                        label: {
                            minFontSize: 5,
                            maxFontSize: 15,
                            style: {
                                color: 'rgba(255,255,255,0.75)'
                            }
                        },
                    },
                    column: {
                        stacking: 'normal',
                    },
                    
                },
                
                series
            }
        },
        wordCloud() {
            var statistics = this.DATATABLE_COMMITTEES.map(c => c.CommitteeName).join(' ')
            .replace(/[():,?0-9]+/g, '').replace('-', '').replace(',', '').split(" ")
            .reduce(function (stat, word) {
                if (!stat[word]) stat[word] = 0;
                stat[word]++;
                return stat;
            }, {});

            var data = [];

            Object.keys(statistics).forEach(key => {
                if (key != 'and' && key != 'the' && key != 'of' && key != 'a' && key != 'to' && key != 'for' && key != 'on' && key != 'in'){
                    if ((this.SELECTED_PARLIAMENTS.length != 0 && this.SELECTED_PARLIAMENTS.length < 5 || this.DATATABLE_COMMITTEES.length < 30)
                    || (this.COMMITTEE_TYPES_SELECTED[0] != 'All types' || this.DATATABLE_COMMITTEES.length < 30)){
                        var obj = {
                            "name": key,
                            "weight": statistics[key]
                        };
                        data.push(obj);
                    }
                    else if (statistics[key] > 3){
                        var obj2 = {
                            "name": key,
                            "weight": statistics[key]
                        };
                        data.push(obj2);
                    }
                }
            });
            
            return {
                chart: {
                    height: 500,
                },
                accessibility: {
                    screenReaderSection: {
                        beforeChartFormat: '<h5>{chartTitle}</h5>' +
                            '<div>{chartSubtitle}</div>' +
                            '<div>{chartLongdesc}</div>' +
                            '<div>{viewTableButton}</div>'
                    }
                },
                series: [{
                    type: 'wordcloud',
                    data,
                    name: 'Occurrences',
                     rotation: {
                        from: 0,
                        to: 0,
                    },
                    minFontSize: 12,
                    maxFontSize: 30
                }],
                title: {
                    text: 'Word cloud derived from Committee names'
                },
                exporting: {
                    filename: 'Word cloud derived from committee names'
                },
                tooltip: {
                    headerFormat: '<span style="font-size: 16px"><b>{point.key}</b></span><br>'
                }
            }
        },
        longestRunningCommittees() {
            var top10Committees = orderBy(this.DATATABLE_COMMITTEES, ['ServiceLength'], ['desc']).slice(0, 10);

            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Longest running committees'
                },
                xAxis: {
                    categories: top10Committees.map(p => p.CommitteeName + ' (' + p.CommitteeType + ')'),
                },
                yAxis: {
                    title: {
                        text: 'Years'
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{y:.2f} years' 
                        }
                    }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y:.2f} years</b><br/>',
                    followPointer: true
                },
                exporting: {
                    filename: 'Longest running committees'
                },
                series: [{
                    name: '',
                    data: top10Committees.map(p => ({
                        color: p.CommitteeChamber == 'House' ? this.$store.state.COLOUR_REPRESENTATIVES 
                        : (p.CommitteeChamber == 'Senate' ? this.$store.state.COLOUR_SENATE_BRIGHT : this.$store.state.COLOUR_JOINT),
                        y: p.ServiceLength / 365,
                    }))
                }],
                legend: {
                    enabled: false
                }
            }
        },
        largestCommittees() {
            var top10Committees = orderBy(this.DATATABLE_COMMITTEES, ['MemberCount'], ['desc']).slice(0, 10);

            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Largest committees by total members since 1901'
                },
                xAxis: {
                    categories: top10Committees.map(p => p.CommitteeName + ' (' + p.CommitteeType + ')'),
                },
                yAxis: {
                    title: {
                        text: 'Total members'
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{y} members' 
                        }
                    }
                },
                exporting: {
                    filename: 'Largest committees by total members'
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y} committee members</b><br/>',
                    followPointer: true
                },
                series: [{
                    name: '',
                    data: top10Committees.map(p => ({
                        color: p.CommitteeChamber == 'House' ? this.$store.state.COLOUR_REPRESENTATIVES 
                        : (p.CommitteeChamber == 'Senate' ? this.$store.state.COLOUR_SENATE_BRIGHT : this.$store.state.COLOUR_JOINT),
                        y: p.MemberCount,
                    }))
                }],
                legend: {
                    enabled: false
                }
            }
        },
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseStats();
            this.FILTER_COMMITTEES();
        }
    },
    mounted() {
        this.onResize();
        if (this.$route.query.committeeTypes) {
            this.COMMITTEE_TYPES_SELECTED = this.$route.query.committeeTypes
                .split(",")
                .map((p) => p.replace("%20", ""));
        } else {
            this.COMMITTEE_TYPES_SELECTED = ["All types"];
        }

        if (this.$route.query.parliaments) {
            this.SELECTED_PARLIAMENTS = this.$route.query.parliaments
                .split(",")
                .map((p) => parseInt(p));
        }

        this.FILTER_COMMITTEES();
    },
    data() {
        return {
        title: 'Committee statistics',
        isMobile: false,
        headers: [],
        items: [],
        stats: [],
        chartType: 'committeesByType',
        PARLIAMENTS: this.$store.getters.GET_PARLIAMENTS,
        SELECTED_PARLIAMENTS: [],
        committees: [],
        currentParliament: 0,
        DATATABLE_COMMITTEES: [],
        COMMITTEE_TYPE_OPTIONS: [
            "All types",
            "House of Representatives Select",
            "House of Representatives Standing",
            "Senate Estimates",
            "Senate Legislative and General Purpose Standing",
            "Senate Select",
            "Senate Standing",
            "Joint Select",
            "Joint Standing",
            "Joint Statutory",
        ],
        COMMITTEE_TYPES_SELECTED: [],
        COMMITTEE_TYPES_SELECTED_PREVIOUS: [],
        totalStats: [],
        committeeData: [],
        ROWS_LISTITEMS: [
        10,
        20,
        50,
        100,
        {
          text: "$vuetify.dataIterator.rowsPerPageAll",
          value: -1,
        },
      ],
        percentage: 0,
        committeeCount: 0,
        currentCommitteeCount: 0,
        totalStatsOptions: {
            suffix: '%'
        },
        PAGINATION: {
            rowsPerPage: 50,
            sortBy: "CommitteeName",
        },
        HEADERS: [
        {
          text: "Committee type",
          value: "CommitteeType",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Committee name",
          value: "CommitteeName",
          align: "left",
          sortable: true,
          model: this.committeeName,
        },
        {
          text: "Member service start",
          value: "StartDate",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Member service end",
          value: "EndDate",
          align: "left",
          sortable: true,
          width: "120px",
        },
        {
          text: "Member count",
          value: "MemberCount",
          align: "left",
          sortable: true,
          width: "80px",
        },
        {
          text: "Service length",
          value: "ServiceLength",
          align: "left",
          sortable: true,
          width: "250px",
        },
      ],
        parties: [],
        partiesExcludingTotal: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        rowsPerPageItems: [ {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    .chamberButton {
        color: #f5f5f5;
    }

    .handbook_toggleButton {
        flex-wrap: wrap;
    }
</style>
<style lang="stylus" scoped>
    .generalPurposeStanding {
        height: 35px !important;
        line-height: 14px;
    }

    .generalPurposeStanding >>> .v-chip__content {
        width: 180px !important;
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }

    @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }
    
</style>